module.exports = [{"name":"superhome","allocation":0,"match":["/","/:organizationName/home"]},{"name":"power_ups","allocation":1,"match":["/power-ups(/)","/power-ups/all","/power-ups/search/:query","/power-ups/category/:idCategory","/power-ups/:idPlugin/:slug","/power-ups/:idPlugin"]},{"name":"search","allocation":0,"match":["/search?q=","/search"]},{"name":"error","allocation":0,"match":["/error"]}]


//////////////////
// WEBPACK FOOTER
// ./app/scripts/singlespa/route-config.json
// module id = fCXB
// module chunks = 13